module.exports = __webpack_public_path__ + "web/img/chapter-40.caf0ef83.png";